import { h, Fragment } from 'preact';

const Icon = ({ id, className }) => {
  const renderIcon = () => {
    switch (id) {
      case 'plus':
        return (
          <svg
            className={className}
            width="12"
            height="11"
            viewBox="0 0 12 11"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <line
              x1="0.949707"
              y1="5.5"
              x2="11.9415"
              y2="5.5"
              stroke="currentColor"
            />
            <line
              x1="6.44531"
              y1="11"
              x2="6.44531"
              y2="2.1872e-08"
              stroke="currentColor"
            />
          </svg>
        );
      case 'minus':
        return (
          <svg
            width="12"
            height="1"
            viewBox="0 0 12 1"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
          >
            <line y1="0.5" x2="12" y2="0.5" stroke="black" />
          </svg>
        );
      case 'pause':
        return (
          <svg
            width="40"
            height="40"
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
          >
            <circle cx="20" cy="20" r="19.5" stroke="black" />
            <rect x="14" y="12" width="4" height="16" rx="1" fill="black" />
            <rect x="22" y="12" width="4" height="16" rx="1" fill="black" />
          </svg>
        );
      case 'play':
        return (
          <svg
            width="50"
            height="50"
            viewBox="0 0 50 50"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
          >
            <circle cx="25" cy="25" r="24.5" stroke="currentColor" />
            <path
              d="M33.5 25.5L22.25 32.4282L22.25 18.5718L33.5 25.5Z"
              fill="currentColor"
            />
          </svg>
        );
      case 'chevron-down':
        return (
          <svg
            width="16"
            height="10"
            viewBox="0 0 16 10"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
          >
            <path
              d="M0.501953 0.833252L8.01069 8.33325L15.5194 0.833252"
              stroke="black"
            />
          </svg>
        );
      case 'chevron-left':
        return (
          <svg
            width="10"
            height="16"
            viewBox="0 0 10 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
          >
            <path
              d="M8.5 1L2 8L8.5 15"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        );
      case 'chevron-right':
        return (
          <svg
            width="10"
            height="16"
            viewBox="0 0 10 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
          >
            <path
              d="M1.5 1L8 8L1.5 15"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        );
      case 'star-full':
        return (
          <svg
            width="12"
            height="12"
            viewBox="0 0 12 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
          >
            <path
              d="M6 0L7.41641 4.58359H12L8.2918 7.41641L9.7082 12L6 9.16718L2.2918 12L3.7082 7.41641L0 4.58359H4.58359L6 0Z"
              fill="currentColor"
            />
          </svg>
        );
      case 'star-half':
        return (
          <svg
            width="36"
            height="36"
            viewBox="0 0 36 36"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
          >
            <path
              d="M18 1.69353L21.7715 13.8984L21.8804 14.2508H22.2492H34.5219L24.5719 21.8519L24.2947 22.0636L24.3977 22.3968L28.185 34.653L18.3035 27.1042L18 26.8723L17.6965 27.1042L7.81495 34.653L11.6023 22.3968L11.7053 22.0636L11.4281 21.8519L1.47815 14.2508H13.7508H14.1196L14.2285 13.8984L18 1.69353Z"
              stroke="black"
            />
            <path
              d="M18 26.5V2L14.5 14.5H2.5L12 22L8.5 33.5L18 26.5Z"
              fill="currentColor"
            />
          </svg>
        );

      case 'star-empty':
        return (
          <svg
            width="36"
            height="36"
            viewBox="0 0 36 36"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
          >
            <path
              d="M18 1.69353L21.7715 13.8984L21.8804 14.2508H22.2492H34.5219L24.5719 21.8519L24.2947 22.0636L24.3977 22.3968L28.185 34.653L18.3035 27.1042L18 26.8723L17.6965 27.1042L7.81495 34.653L11.6023 22.3968L11.7053 22.0636L11.4281 21.8519L1.47815 14.2508H13.7508H14.1196L14.2285 13.8984L18 1.69353Z"
              stroke="currentColor"
            />
          </svg>
        );
      case 'close':
        return (
          <svg
            width="41"
            height="41"
            viewBox="0 0 41 41"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={!className ? 'text-white' : className}
          >
            <circle cx="20.5" cy="20.5" r="20.5" fill="currentColor" />
            <path d="M13.667 28.0505L27.3337 13.8099" stroke="#222222" />
            <path d="M13.667 13.8101L27.3337 28.0507" stroke="#222222" />
          </svg>
        );
      case 'remove':
        return (
          <svg
            width="38"
            height="35"
            viewBox="0 0 38 35"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M37.5 6C37.5 2.96243 35.0376 0.5 32 0.5H6C2.96243 0.5 0.5 2.96243 0.5 6V29C0.5 32.0376 2.96243 34.5 6 34.5H32C35.0376 34.5 37.5 32.0376 37.5 29V6Z"
              fill="#F5F2EF"
              stroke="#DDDDDD"
            />
            <path
              d="M10.5457 10.0608H15.8752V8.51424C15.8752 8.15551 16.1836 7.875 16.5456 7.875H21.4547C21.8167 7.875 22.1251 8.15553 22.1251 8.51424V10.0606L27.4546 10.0608C27.4546 10.0608 27.4546 10.0608 27.4546 10.0608C27.8166 10.0608 28.125 10.3413 28.125 10.7C28.125 11.0587 27.8166 11.3393 27.4546 11.3393H25.7796V25.4858C25.7796 25.8445 25.4712 26.125 25.1092 26.125H12.891C12.529 26.125 12.2206 25.8445 12.2206 25.4858L12.2204 11.3393H10.5454C10.1834 11.3393 9.875 11.0587 9.875 10.7C9.875 10.3412 10.1838 10.0608 10.5457 10.0608ZM20.7843 9.15349H17.2162V9.93198L20.7843 9.93214V9.15349ZM13.5616 24.8464H24.4388V11.3392H13.5616V24.8464ZM15.8751 22.22V13.9914C15.8751 13.603 16.1879 13.3521 16.5455 13.3521C16.9075 13.3521 17.2159 13.6326 17.2159 13.9914V22.22C17.2159 22.5787 16.9075 22.8592 16.5455 22.8592C16.1835 22.8592 15.8751 22.5787 15.8751 22.22ZM20.7841 22.22V13.9914C20.7841 13.6031 21.0968 13.3521 21.4545 13.3521C21.8165 13.3521 22.1249 13.6326 22.1249 13.9914V22.22C22.1249 22.5787 21.8165 22.8592 21.4545 22.8592C21.0925 22.8592 20.7841 22.5787 20.7841 22.22Z"
              fill="#484848"
              stroke="#484848"
              stroke-width="0.25"
            />
          </svg>
        );
      case 'rewards':
        return (
          <svg
            width="42"
            height="15"
            viewBox="0 0 42 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M11.6399 5.32154C11.1415 5.32154 10.7074 5.209 10.3537 4.99999C9.98391 4.79099 9.7106 4.48553 9.51768 4.0836C9.32475 3.69775 9.22829 3.23151 9.22829 2.70096V2.63665C9.22829 2.2508 9.2926 1.89711 9.40514 1.57556C9.51768 1.25402 9.69452 0.980707 9.9196 0.739549C10.1447 0.498392 10.4019 0.321543 10.6913 0.192926C10.9807 0.0643084 11.3022 0 11.6559 0C12.0096 0 12.3473 0.0643084 12.6527 0.192926C12.9582 0.321543 13.1993 0.498392 13.4083 0.755627C13.6013 1.01286 13.7299 1.31833 13.762 1.6881H13.135C13.0707 1.28617 12.926 0.996783 12.6849 0.78778C12.4437 0.594854 12.1061 0.482315 11.672 0.482315C11.3987 0.482315 11.1575 0.530547 10.9485 0.62701C10.7235 0.723473 10.5466 0.868166 10.3858 1.06109C10.2251 1.25402 10.1125 1.4791 10.0161 1.73633C9.93568 1.99357 9.88745 2.29903 9.88745 2.62058V2.68489C9.88745 3.11897 9.95176 3.50482 10.0965 3.81029C10.2411 4.13183 10.4502 4.37299 10.7074 4.53376C10.9646 4.69453 11.2862 4.79099 11.6559 4.79099C12.0739 4.79099 12.4276 4.67845 12.701 4.46945C12.9743 4.26045 13.1511 3.9389 13.2154 3.5209H13.8103C13.746 3.92283 13.6174 4.24437 13.4244 4.51768C13.2315 4.79099 12.9743 4.98392 12.6688 5.11254C12.3633 5.24115 12.0257 5.30546 11.6399 5.30546V5.32154Z"
              fill="white"
            />
            <path
              d="M14.2604 5.25723L16.045 0.0803833H16.8649L18.6173 5.25723H17.9903L17.4759 3.76205H15.3376L14.8392 5.25723H14.2444H14.2604ZM16.4309 0.610929L15.5305 3.27974H17.3312L16.4309 0.610929Z"
              fill="white"
            />
            <path
              d="M19.5177 5.25723V0.0803833H21.0771C21.4148 0.0803833 21.7042 0.128615 21.9775 0.225078C22.2508 0.321541 22.4598 0.482312 22.6366 0.691315C22.7974 0.900318 22.8778 1.17363 22.8778 1.52733V1.55948C22.8778 1.84887 22.8135 2.09003 22.7009 2.28295C22.5884 2.47588 22.4276 2.62057 22.2347 2.73311C22.0418 2.84565 21.8328 2.92604 21.5916 2.97427L23.1833 5.2733H22.4759L20.9325 3.0225H20.1286V5.2733H19.5016L19.5177 5.25723ZM20.1447 2.50803H21.1093C21.3505 2.50803 21.5595 2.47588 21.7363 2.39549C21.8971 2.33118 22.0257 2.21864 22.1222 2.07395C22.2186 1.92926 22.2508 1.75241 22.2508 1.5434V1.51125C22.2508 1.27009 22.2025 1.09324 22.1222 0.94855C22.0257 0.819932 21.8971 0.723469 21.7363 0.65916C21.5755 0.594852 21.3665 0.578774 21.1254 0.578774H20.1608V2.49196L20.1447 2.50803Z"
              fill="white"
            />
            <path
              d="M25.2411 5.25723L23.4887 0.0803833H24.1157L25.6591 4.6463L27.2025 0.0803833H27.7974L26.0128 5.25723H25.2572H25.2411Z"
              fill="white"
            />
            <path
              d="M28.6495 5.25723V0.0803833H31.672V0.594852H29.2926V2.34726H31.2218V2.86173H29.2926V4.74276H31.8167V5.25723H28.6656H28.6495Z"
              fill="white"
            />
            <path
              d="M0 14.9035V8.58521H2.07395C2.52411 8.58521 2.92604 8.64951 3.27974 8.77813C3.63344 8.90675 3.90675 9.09967 4.09968 9.37299C4.2926 9.6463 4.40514 9.98392 4.40514 10.418V10.4502C4.40514 10.7878 4.34083 11.0611 4.21222 11.3022C4.0836 11.5273 3.90675 11.7203 3.69775 11.8489C3.48874 11.9936 3.23151 12.09 2.97427 12.1543L4.79099 14.9035H3.61736L1.91318 12.299H1.10932V14.9035H0.0321543H0ZM1.07717 11.5112H2.07395C2.34726 11.5112 2.57235 11.4791 2.76527 11.3987C2.9582 11.3183 3.08681 11.2058 3.18328 11.045C3.27974 10.8842 3.32797 10.6913 3.32797 10.4662V10.4341C3.32797 10.1768 3.27974 9.98392 3.18328 9.83922C3.08681 9.69453 2.94212 9.58199 2.76527 9.51768C2.58842 9.45337 2.36334 9.42122 2.10611 9.42122H1.09325V11.5112H1.07717Z"
              fill="white"
            />
            <path
              d="M5.73954 14.9035V8.58521H9.63021V9.43729H6.81671V11.2701H9.06751V12.1061H6.81671V14.0514H9.77491V14.9035H5.73954Z"
              fill="white"
            />
            <path
              d="M11.9775 14.9035L10.3698 8.58521H11.4791L12.6206 13.3601L13.9228 8.58521H14.7588L16.0932 13.3923L17.2669 8.58521H18.2797L16.672 14.9035H15.6591L14.373 10.2412L13.0386 14.9035H11.9936H11.9775Z"
              fill="white"
            />
            <path
              d="M18.2315 14.9035L20.3698 8.58521H21.7845L23.8746 14.9035H22.7653L22.2347 13.2797H19.791L19.2604 14.9035H18.2476H18.2315ZM21.0128 9.46945L20.0321 12.4759H21.9935L21.0128 9.46945Z"
              fill="white"
            />
            <path
              d="M24.8714 14.9035V8.58521H26.9453C27.3955 8.58521 27.7974 8.64951 28.1511 8.77813C28.5048 8.90675 28.7781 9.09967 28.971 9.37299C29.164 9.6463 29.2765 9.98392 29.2765 10.418V10.4502C29.2765 10.7878 29.2122 11.0611 29.0836 11.3022C28.955 11.5273 28.7781 11.7203 28.5691 11.8489C28.3601 11.9936 28.1029 12.09 27.8456 12.1543L29.6624 14.9035H28.4887L26.7845 12.299H25.9807V14.9035H24.9035H24.8714ZM25.9485 11.5112H26.9453C27.2186 11.5112 27.4437 11.4791 27.6366 11.3987C27.8296 11.3183 27.9582 11.2058 28.0546 11.045C28.1511 10.8842 28.1993 10.6913 28.1993 10.4662V10.4341C28.1993 10.1768 28.1511 9.98392 28.0546 9.83922C27.9582 9.69453 27.8135 9.58199 27.6366 9.51768C27.4598 9.45337 27.2347 9.42122 26.9775 9.42122H25.9646V11.5112H25.9485Z"
              fill="white"
            />
            <path
              d="M30.6109 14.9035V8.58521H32.4759C33.1993 8.58521 33.8103 8.71382 34.2926 8.98713C34.7749 9.26045 35.1286 9.61414 35.3697 10.0804C35.6109 10.5466 35.7234 11.0772 35.7234 11.6881V11.7685C35.7234 12.3794 35.6109 12.91 35.3697 13.3923C35.1286 13.8746 34.7749 14.2444 34.2926 14.5177C33.8103 14.791 33.1993 14.9196 32.4598 14.9196H30.6109V14.9035ZM31.7041 14.0514H32.4276C32.9099 14.0514 33.3279 13.955 33.6495 13.7781C33.971 13.6013 34.2122 13.328 34.373 12.9903C34.5337 12.6527 34.6141 12.2347 34.6141 11.7685V11.7042C34.6141 11.2379 34.5337 10.8521 34.389 10.5145C34.2443 10.1768 34.0032 9.91961 33.6816 9.74276C33.3601 9.56591 32.9421 9.46945 32.4276 9.46945H31.7041V14.0836V14.0514Z"
              fill="white"
            />
            <path
              d="M38.9228 15C38.344 15 37.8778 14.9035 37.5241 14.7267C37.1704 14.5498 36.8971 14.3087 36.7202 14.0032C36.5434 13.6977 36.4469 13.344 36.3987 12.9582H37.4276C37.4598 13.1833 37.508 13.3762 37.6045 13.5691C37.7009 13.7621 37.8456 13.9067 38.0386 14.0193C38.2476 14.1318 38.5369 14.1801 38.9067 14.1801C39.1479 14.1801 39.3569 14.1318 39.5498 14.0514C39.7427 13.9711 39.8874 13.8424 39.9839 13.6977C40.0964 13.537 40.1447 13.3601 40.1447 13.1511C40.1447 12.9421 40.0964 12.7813 40.016 12.6367C39.9357 12.508 39.807 12.3955 39.598 12.3151C39.4051 12.2347 39.1157 12.1543 38.762 12.1061C38.2797 12.0418 37.8778 11.9293 37.5562 11.8006C37.2347 11.672 36.9775 11.4791 36.8167 11.2379C36.6559 10.9968 36.5755 10.6913 36.5755 10.3055C36.5755 9.96784 36.672 9.66238 36.8488 9.38907C37.0257 9.11575 37.2829 8.90675 37.6045 8.74598C37.926 8.58521 38.3119 8.50482 38.7299 8.50482C39.4051 8.50482 39.9357 8.66559 40.3215 8.97106C40.7074 9.27653 40.9324 9.72669 40.9967 10.3215H40C39.9357 9.96784 39.807 9.72669 39.598 9.56591C39.389 9.40514 39.0996 9.32476 38.7138 9.32476C38.3279 9.32476 38.0546 9.40514 37.8617 9.56591C37.6688 9.72669 37.5723 9.93569 37.5723 10.1929C37.5723 10.3698 37.6045 10.5305 37.6688 10.6592C37.7331 10.7878 37.8617 10.8842 38.0707 10.9807C38.2797 11.0772 38.553 11.1415 38.9389 11.1897C39.4212 11.254 39.8231 11.3505 40.1607 11.4952C40.4984 11.6238 40.7395 11.8167 40.9164 12.0739C41.0932 12.3151 41.1736 12.6527 41.1736 13.0707C41.1736 13.4244 41.0771 13.7621 40.8842 14.0514C40.6913 14.3408 40.418 14.582 40.0803 14.7428C39.7427 14.9196 39.3408 15 38.8746 15H38.9228Z"
              fill="white"
            />
          </svg>
        );
      default:
        return null;
    }
  };

  return <Fragment>{renderIcon()}</Fragment>;
};

export default Icon;
